export function useAppShellLayoutReturn({ chat, handlers, secondaryNavProps }) {
  return {
    activePrimaryKey: chat.activePrimaryKey,
    handlePrimaryNavChange: handlers.handlePrimaryNavChange,
    handleAccountMenuAction: chat.handleAccountMenuAction,
    secondaryNavProps,
    mainLayoutProps: chat.mainLayoutProps,
    threadShareThread: chat.threadShareThread,
  }
}
